module.exports = {"520121100":"城关镇","520121101":"双流镇","520121102":"金中镇","520121103":"冯三镇","520121104":"楠木渡镇","520121105":"龙岗镇","520121106":"永温镇","520121107":"花梨镇","520121200":"南龙乡","520121202":"宅吉乡","520121204":"龙水乡","520121205":"米坪乡","520121206":"禾丰布依族苗族乡","520121207":"南江布依族苗族乡","520121208":"高寨苗族布依族乡","520121209":"毛云乡","520121401":"紫兴社区服务中心","520121402":"南山社区服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520121.json
// module id = 2267
// module chunks = 0